import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { VeloClient } from './velo-client.js';

export function useVeloClient(): VeloClient {
  const httpClient = useHttpClient({ type: 'code' });
  const client = useMemo(() => new VeloClient(httpClient), [httpClient]);

  return usePanoramaMethodLogger(client);
}
